import { Typography, Box } from "@material-ui/core"
import PropTypes from "prop-types"
import React from "react"
import useStyles from "./styles"

const EstimateForBox = ({ label = "", phoneLabel = "", data = "" }) => {
  const classes = useStyles()

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth
  return data ? (
    <Box display="flex">
      {label !== "" && (
        <Typography align="left" className={classes.subtitle}>
          {viewportWidth > 600 ? label + ": " : phoneLabel + ": "}
        </Typography>
      )}
      <Typography align="left" className={classes.data}>
        {data}
      </Typography>
    </Box>
  ) : null
}

EstimateForBox.propTypes = {
  label: PropTypes.string,
  phoneLabel: PropTypes.string,
  data: PropTypes.string,
}

export default EstimateForBox
